{
  "ChangeMenuTitle": "Relatório de alterações",
  "UnknownReport": "[Relatório Desconhecido]",
  "NoSuitableReportsAvailable": "Não há relatórios adequados disponíveis.",
  "DashboardChangeFolderEmpty": "Todos os relatórios nesta pasta já foram usados neste painel...",
  "DashboardList_SectionHeader": "Lista",
  "DashboardList_Add": "Adicionar",
  "DashboardList_AddMenuTitle": "Adicionar e remover",
  "DashboardList_MoveUp": "Subir",
  "DashboardList_MoveDown": "Mover para baixo",
  "DashboardList_Remove": "Remover",
  "DashboardList_RemoveAll": "Deletar tudo",
  "DashboardList_RemoveAllConfirmMessage": "Tem certeza de que deseja remover todos os relatórios?",
  "NAME": "DashboardList"
}